import type { SnapshotFrom } from 'xstate';
import { feature, useFeature } from '@/app/context';
import { scheduleMachine } from './schedule.machine';

export const useScheduleRef = () => feature('schedule');
export const useSchedule = <R>(selector: (snapshot: SnapshotFrom<typeof scheduleMachine>) => R) =>
  useFeature('schedule', selector);
export const useScheduleActions = () => {
  const ref = useScheduleRef();
  return {
    loadBrowse: () => ref.send({ type: 'schedule.load-browse' }),
    publish: (input: Omit<Extract<Parameters<typeof ref.send>[0], { type: 'schedule.publish' }>, 'type'>) =>
      ref.send({ type: 'schedule.publish', ...input }),
  };
};
